import { AppForm } from '../../../../../../../common/forms/app.form';
import { inject, Injectable, Signal } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ObrebAppEntityDictionaryObreb,
  ObrebService
} from '../../../../../../../openapi';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable()
export class OpinionOfConformityPropertyDataForm extends AppForm {

  private obrebService: ObrebService = inject(ObrebService);

  public obrebList: Signal<ObrebAppEntityDictionaryObreb[] | undefined> = toSignal(this.obrebService.getObrebCollectionObrebCollection({
    pagination: false,
    orderName: 'asc'
  }));

  constructor() {
    super({
      city: new FormControl(null, [Validators.maxLength(255)]),
      postalCode: new FormControl(null, [Validators.maxLength(255)]),
      street: new FormControl(null, [Validators.maxLength(255)]),
      houseNumber: new FormControl(null, [Validators.maxLength(255)]),
      registrationNumber: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      precint: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.maxLength(255)] }),
    });
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchValue({
      ...value,
      precint: value?.precint || ''
    })
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      ...this.value
    };
  }
}
